import * as identityConstants from "../constants/identity.constants";
import { IdentityAction } from '../actions'
import { ILocalizedError } from 'src/i18n/error-localization';
import { IIdentityEntries } from 'src/contracts/IIdentityEntries';
import { IIdentityDto } from 'src/services';

const initialState: IIdentityEntries = {
    entities: [],
    error: null,
    isLoading: false,
}

export const identitiesReducer = (state: IIdentityEntries = initialState, action: IdentityAction) => {
    switch (action.type) {
        case identityConstants.IDENTITY_LOAD_SUCCESS:
            return handleLoadCompleted(state, action.payload)
        case identityConstants.IDENTITY_REQUEST:
            return handleRequestInitiated(state);
        case identityConstants.IDENTITY_FAILURE:
            return handleRequestFailed(state, action.payload)
        case identityConstants.IDENTITY_DELETE_SUCCESS:
            return handleDeleteCompleted(state, action.payload)
        case identityConstants.IDENTITY_CREATE_SUCCESS:
            return handleCreateCompleted(state, action.payload)            
    }

    return state;
}

const handleRequestInitiated = (state: IIdentityEntries) => {
    const newState = Object.assign({}, state)
    newState.isLoading = true
    return newState
}

const handleRequestFailed = (state: IIdentityEntries, payload: ILocalizedError) => {
    const newState = Object.assign({}, state)
    newState.isLoading = false
    newState.error = payload
    return newState
}

const handleLoadCompleted = (state: IIdentityEntries, payload: IIdentityEntries) => {
    const newState = Object.assign({}, state)
    newState.isLoading = payload.isLoading
    newState.entities = payload.entities

    return newState
}

const handleCreateCompleted = (state: IIdentityEntries, payload: IIdentityDto) => {
    const newState = Object.assign({}, state)
    newState.isLoading = false
    newState.entities = [payload, ...state.entities]

    return newState
}

const handleDeleteCompleted = (state: IIdentityEntries, payload: {id: string}) => {
    const newState = Object.assign({}, state)
    newState.isLoading = false
    newState.entities = newState.entities.filter(a => a.id !== payload.id)

    return newState
}


// WEBPACK FOOTER //
// ./src/reducers/identities.reducer.ts